var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTranslation = function SvgIconTranslation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_translation_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.792 4.375h2.333c.322 0 .583.261.583.583v8.167a.583.583 0 0 1-.583.583H4.958a.583.583 0 0 1-.583-.583v-2.333M9.5.5h-9v9H5L9.5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.332 2.978h2.1m0 0h1.4m-1.4 0v-.644m2.567.644H5.832m0 0c-.247.88-.761 1.712-1.35 2.443m0 0a15 15 0 0 1-1.5 1.58m1.5-1.58c-.3-.352-.72-.92-.84-1.178m.84 1.178.9.936M7.664 11.666l.555-1.333m0 0 1.112-2.667 1.111 2.667m-2.223 0h2.223m.555 1.333-.555-1.333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_translation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgIconTranslation;